module.exports = __webpack_public_path__ + "img/header.4a3f9677.png";